import * as React from 'react';
import { observer, inject } from 'mobx-react';
import { PaneHeader, Page, Pane, PaneBackButton, PaneBody } from '../../atoms/applications/page';
import { ApplicationPageState } from '../../../containers/application/states/ApplicationPageState';
import { UserAddressForm } from '../../molecules/applications/UserAddressForm';

type Props = {
  applicationState: ApplicationPageState;
  nextButtonLabel?: string;
};

export const UserAddressPane = inject('applicationState')(
  observer(
    class UserAddressPane extends React.Component<Props> {
      render() {
        const {
          applicationState: {
            addressFormState,
            validateUserAddressAndNext,
            canGoBack,
            submitState: { submitting },
          },
          nextButtonLabel,
        } = this.props;
        return (
          <Page>
            <Pane>
              {canGoBack && <PaneBackButton />}
              <PaneHeader>住所情報の入力</PaneHeader>
              <PaneBody>
                <UserAddressForm
                  submitting={submitting}
                  state={addressFormState}
                  onSubmit={validateUserAddressAndNext}
                  buttonLabel={nextButtonLabel || '内容の確認へ'}
                />
              </PaneBody>
            </Pane>
          </Page>
        );
      }
    }
  )
);
